import React from "react";
import { Table } from "reactstrap";

const StationInfoCard = ({ station }) => {
  return (
    <div className="bordered bg-light">
      <img
        className="station_img"
        src="https://images.unsplash.com/photo-1663534346049-b8874aae17ba?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHw3fHx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60"
      />
      <div className="p-4">
        <p className="font-weight-bold">Байршил</p>
        <p className="font-size-14 font-weight-400">{station.location}</p>
        <div className="d-flex font-size-14 align-items-center mt-4">
          <div className="icon-container ms-3">
            <img alt="office" src="/images/contact.svg" height={12} />
          </div>
          {/* {station.phone} */}
          7007 3001, 7007 3001
        </div>
        <div className="d-flex font-size-14 align-items-center mt-3">
          <div className="icon-container ms-3">
            <img alt="office" src="/images/time.svg" height={12} />
          </div>
          {/* {station.timeTable} */}
          Да - Ба 09:00 - 18:00
        </div>
        <Table bordered className="station_price_table mt-4">
          <thead>
            <tr className="font-size-14 font-weight-bold">
              <th>Шатахуун</th>
              <th>Үндсэн үнэ</th>
              <th>Урамшуулалт үнэ</th>
            </tr>
          </thead>
          <tbody>
            {station.available_gases.map((gas, index) => {
              return (
                <tr className="font-size-14" key={index}>
                  <td>{gas}</td>
                  <td>2390₮</td>
                  <td>2350₮</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        <p className="font-weight-bold mt-4">Нэмэлт үйлчилгээ </p>
        <div className="d-flex column">
          {station.additionalServices.map((service, index) => {
            return (
              <div
                className="d-flex font-size-12 align-items-center mt-2"
                key={index}
              >
                <div className="icon-container station_sm_icon ms-3 ">
                  <img alt="office" src="/images/contact.svg" height={6} />
                </div>
                <div className="ms-3">{service}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default StationInfoCard;
